import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { FormatOfCreativeListResponse } from '@modules/creatives-link/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  CREATIVES_LINK_PERMISSIONS,
  LOAD_FORMAT_FOR_CREATIVE_API_URL,
  LOAD_FORMAT_FOR_CREATIVE_QUERY_KEY,
} from '@modules/creatives-link/constants';

export default function useFormatOfCreativeListQuery(
  merchant: Ref<number | undefined>,
  trackerRef: Ref<string | undefined>,
): IContextQueryResult<FormatOfCreativeListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<FormatOfCreativeListResponse>({
    queryKey: [LOAD_FORMAT_FOR_CREATIVE_QUERY_KEY, merchant, trackerRef],
    queryFn: ({ signal }) => fetchGet<FormatOfCreativeListResponse>(
      LOAD_FORMAT_FOR_CREATIVE_API_URL,
      {
        signal,
        permission: CREATIVES_LINK_PERMISSIONS.SHOW,
        queryParams: {
          merchant: merchant.value,
        },
      },
    ),
    gcTime: 0,
    enabled: computed(() => !!merchant.value && !!trackerRef.value),
  });
}
